class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new window.PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 0.5,
      maxZoomLevel: 'fill',
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,

      closeOnVerticalDrag: true,

      tapAction: 'zoom',

      pswpModule: () => {
        return window.PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('afterInit', () => {
      this.setupCarouselA11y()
    })

    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
    })
  }

  setupCarouselA11y () {
    const scrollWrap = this.photoSwipeInstance?.pswp?.scrollWrap

    if (!scrollWrap) return

    const zoomCarouselLabel = 'zoom carousel'

    scrollWrap.setAttribute('role', 'region')
    scrollWrap.setAttribute('aria-label', zoomCarouselLabel)

    if (scrollWrap.querySelector('[data-pswp-carousel-instructions]')) return

    const instructionsEl = document.createElement('p')

    instructionsEl.className = 'util-ScreenReaderOnly'
    instructionsEl.setAttribute('data-pswp-carousel-instructions', 'true')
    instructionsEl.textContent =
      'Carousel. Use left and right arrow keys to navigate between slides.'

    scrollWrap.prepend(instructionsEl)
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let thumbEl
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = (event) => {
            pswp.goTo(dotEls.indexOf(event.target))
          }

          thumbEl = document.createElement('img')
          thumbEl.className = 'pswp-Action_DotImage'
          thumbEl.src = this.els.link.elements[i].dataset.thumbImage

          dotEl.appendChild(thumbEl)
          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  get closeSvg () {
    return '<span class="util-ScreenReaderOnly fz-10_150">Close</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7 17.5L17.5 7" stroke="black"/><path d="M7 7L17.5 17.5" stroke="black"/></svg>'
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
